export const isValueExistsInEnum = <T extends object>(value: string, enumValues: T): boolean => {
  return Object.values(enumValues).includes(value);
};
